import { createContext, useContext, useEffect, useState, useCallback } from "react";

const DICT = {
  pt: {
    nav: {
      avisos: "Avisos", avisosDesc: "Comunicados importantes do WX SyncVods.",
      suporte: "Suporte", suporteDesc: "Fale com nossa equipe.",
      suporteBody: "Tem alguma dúvida sobre planos ou sincronização? Fale com a gente no Telegram — respondemos rapidinho.",
      telegramBtn: "Falar no Telegram", meuPainel: "Meu Painel",
      acessar: "Acessar meu painel", acessarDesc: "Cole o código único que você recebeu na compra.",
      entrar: "Entrar", codePlaceholder: "ex: bb70f097-7c16-4e6c-93b1-e3f38cda0d62",
    },
    landing: {
      expiryWarn: "Atenção: mantenha sua assinatura ativa para garantir a sincronização automática de novos conteúdos.",
      intro: "Esse script permite você cadastrar filmes e séries (VODs) automaticamente em um servidor da sua escolha.",
      contactBefore: "Entre em contato com nossa equipe para saber se esse script é útil pra você antes de comprar.",
      supported: "Sistemas suportados:", subscribe30: "Assinar por 30 dias", buyOne: "Comprar 1 sincronia",
      footer: "WX SyncVods — Sincronizador de VODs para XUI ONE, XTREAM UI, STREAMCREED, 1-STREAM e mais",
    },
    plans: {
      period30: "por 30 dias", periodOnce: "1 sincronia",
      ctaSub: "Assinar por 30 dias", ctaOnce: "Comprar 1 Sincronia",
      badgeMost: "Mais Escolhido", badgeBest: "Melhor Custo",
      descMoviesSeries: "Sincronização ilimitada e automática de filmes e séries para 1 servidor.",
      descMovies: "Sincronização ilimitada e automática de filmes para 1 servidor.",
      descSeries: "Sincronização ilimitada e automática de séries para 1 servidor.",
      descOnce: "Essa opção permite você sincronizar 1 vez para 1 servidor por 24 horas.",
      infoOnce: "Depois de 24 horas você precisará comprar outra sincronia caso queira usar novamente o script.",
      titleMoviesSeries: "Filmes e Séries", titleMovies: "Filmes", titleSeries: "Séries",
    },
    checkout: {
      back: "Voltar aos planos", buying: "Você está comprando", planNotFound: "Plano não encontrado.", backBtn: "Voltar",
      approvedTitle: "Pagamento aprovado!", sentCode: "Enviamos o seu código para", yourCode: "Seu código único",
      gotoPanel: "Ir para meu painel", pixTitle: "Pague com PIX", pixDesc: "Escaneie o QR Code ou copie o código abaixo.",
      pixCopied: "Código PIX copiado!", waitingPix: "Aguardando confirmação do pagamento…",
      boletoTitle: "Boleto gerado", boletoDesc: "Abra o boleto, pague e seu painel será liberado após a compensação.",
      openBoleto: "Abrir boleto", waiting: "Aguardando pagamento…",
      emailLabel: "Seu e-mail (para receber o código)", emailPlaceholder: "voce@email.com",
      emailInvalid: "Informe um e-mail válido", continue: "Continuar para o pagamento",
      choosePayment: "Escolha PIX, cartão de crédito ou boleto — tudo aqui no site.",
      codeCopied: "Código copiado!", status: "Status",
    },
    panel: {
      clientPanel: "Painel do cliente", daysRemaining: "Dias restantes", expiresAt: "Expira em", system: "Sistema",
      statusActive: "Ativo", statusSuspended: "Suspenso", statusPending: "Aguardando pagamento",
      stepLabel: "Etapa", renewBtn: "Renovar / Comprar plano",
      inactiveSuspended: "Sua assinatura expirou. Renove um plano para reativar a sincronização. Seu código e link continuam válidos após a renovação.",
      inactivePending: "Estamos aguardando a confirmação do seu pagamento. Assim que for aprovado, esta página liberará a configuração.",
      syncId: "ID da Sincronia", copyHint: "Copie essa informação caso precise entrar em contato conosco.",
      notFoundTitle: "Código não encontrado", notFoundDesc: "Verifique se o código do seu painel está correto.",
      backToPlans: "Voltar aos planos", codeCopied: "Código copiado!",
    },
    step1: {
      attention: "ATENÇÃO: leia atentamente cada detalhe dessa página. Só entre em contato com o suporte se não entender.",
      selectSystem: "Selecione o tipo do seu sistema abaixo:",
      oneServerNote: "Você pode utilizar a sincronia quantas vezes quiser em 1 servidor. Se você tem mais de 1 servidor, chame o suporte.",
      serverData: "Dados do Servidor", manualTitle: "Configuração Manual",
      manualDesc: "Se você não tem o usuário do banco do seu MAIN, crie um novo rodando os comandos abaixo via SSH no seu servidor MAIN.",
      copyUseSuggested: "Copiar e usar usuário e senha sugerido", autoTitle: "Configuração Automática",
      autoDesc: "Para configurar o IP do main, criar um novo usuário de banco e liberar o firewall, copie e execute o comando abaixo no seu servidor via SSH:",
      copyCommand: "Copiar Comando", commandCopied: "Comando copiado!", cmdsCopied: "Comandos copiados!",
      ipLabel: "IP do Servidor MAIN *", ipLocked: "IP fixo — bloqueado após o 1º cadastro. Para trocar, fale com o suporte.",
      ipPlaceholder: "Ex: 45.180.20.150", portLabel: "Porta do Banco de Dados *", dbNameLabel: "Nome do Banco *",
      dbUserLabel: "Usuário do Banco de Dados *", dbUserPlaceholder: "usuário", dbPassLabel: "Senha do Banco",
      dbPassPlaceholder: "Deixe em branco pra usar a senha existente",
      notifData: "Dados para Notificação", botAccess: "Acesso ao Bot do Telegram",
      botS1: "Clique no botão abaixo para abrir o nosso bot.", botS2: "Dentro do bot, toque em Start (Iniciar).",
      botS3: "O bot vai te enviar o seu Chat ID — copie o número.", botS4: "Cole o Chat ID no campo abaixo e clique em Avançar para salvar.",
      openBot: "Abrir o Bot do Telegram", sendTest: "Enviar teste", chatIdLabel: "Telegram Chat ID",
      chatIdRegistered: "Cadastrado. Você pode alterar o Chat ID quando quiser (troca de conta/bot).",
      testConn: "Testar conexão", fillIpUser: "Preencha o IP e o usuário do banco.",
      savedStep1: "Etapa 1 salva! Vamos para as configurações de sincronização.",
    },
    common: { back: "Voltar", saveAdvance: "Salvar e avançar", saveStartSync: "Salvar e iniciar sincronização", advance: "Avançar", loading: "Carregando…" },
    steps: {
      s2movies: "Configurações de Filmes", s2series: "Configurações de Séries",
      s3how: "Como deseja informar sua M3U?", s3source: "Sua fonte M3U", s3settings: "Configurações",
      s4tmdb: "Configurações do TMDB", s4movies: "Configurações de Filmes", s4series: "Configurações de Séries",
      s5maint: "Ferramentas de Manutenção", s5progress: "Progresso geral", s5remaining: "Restam",
      s5copy: "Copiar", s5msgCopied: "Mensagem copiada!",
      s5autoOn: "Sincronia Automática", s5autoOff: "Ativar Sincronia Automática",
      s5stop: "Parar Sincronia", s5restart: "Reiniciar Sincronia",
      s5every: "Sincronizar todo dia às", s5deact: "Desativar", s5saveAct: "Salvar e ativar",
      s5chgConfig: "Alterar Configuração", s5chgSystem: "Alterar Sistema",
    },
  },
  en: {
    nav: {
      avisos: "News", avisosDesc: "Important announcements from WX SyncVods.",
      suporte: "Support", suporteDesc: "Talk to our team.",
      suporteBody: "Questions about plans or syncing? Message us on Telegram — we reply fast.",
      telegramBtn: "Chat on Telegram", meuPainel: "My Panel",
      acessar: "Access my panel", acessarDesc: "Paste the unique code you received on purchase.",
      entrar: "Enter", codePlaceholder: "e.g. bb70f097-7c16-4e6c-93b1-e3f38cda0d62",
    },
    landing: {
      expiryWarn: "Note: keep your subscription active to guarantee automatic syncing of new content.",
      intro: "This tool automatically adds movies and series (VODs) to a server of your choice.",
      contactBefore: "Contact our team to check if this tool is useful for you before buying.",
      supported: "Supported systems:", subscribe30: "Subscribe for 30 days", buyOne: "Buy 1 sync",
      footer: "WX SyncVods — VOD synchronizer for XUI ONE, XTREAM UI, STREAMCREED, 1-STREAM and more",
    },
    plans: {
      period30: "per 30 days", periodOnce: "1 sync",
      ctaSub: "Subscribe for 30 days", ctaOnce: "Buy 1 Sync",
      badgeMost: "Most Popular", badgeBest: "Best Value",
      descMoviesSeries: "Unlimited automatic syncing of movies and series for 1 server.",
      descMovies: "Unlimited automatic syncing of movies for 1 server.",
      descSeries: "Unlimited automatic syncing of series for 1 server.",
      descOnce: "This option lets you sync once to 1 server for 24 hours.",
      infoOnce: "After 24 hours you'll need to buy another sync if you want to use the tool again.",
      titleMoviesSeries: "Movies & Series", titleMovies: "Movies", titleSeries: "Series",
    },
    checkout: {
      back: "Back to plans", buying: "You are buying", planNotFound: "Plan not found.", backBtn: "Back",
      approvedTitle: "Payment approved!", sentCode: "We sent your code to", yourCode: "Your unique code",
      gotoPanel: "Go to my panel", pixTitle: "Pay with PIX", pixDesc: "Scan the QR Code or copy the code below.",
      pixCopied: "PIX code copied!", waitingPix: "Waiting for payment confirmation…",
      boletoTitle: "Boleto generated", boletoDesc: "Open the boleto, pay it and your panel unlocks after clearing.",
      openBoleto: "Open boleto", waiting: "Waiting for payment…",
      emailLabel: "Your e-mail (to receive the code)", emailPlaceholder: "you@email.com",
      emailInvalid: "Enter a valid e-mail", continue: "Continue to payment",
      choosePayment: "Choose PIX, credit card or boleto — all here on the site.",
      codeCopied: "Code copied!", status: "Status",
    },
    panel: {
      clientPanel: "Customer panel", daysRemaining: "Days remaining", expiresAt: "Expires on", system: "System",
      statusActive: "Active", statusSuspended: "Suspended", statusPending: "Awaiting payment",
      stepLabel: "Step", renewBtn: "Renew / Buy plan",
      inactiveSuspended: "Your subscription expired. Renew a plan to reactivate syncing. Your code and link remain valid after renewal.",
      inactivePending: "We're waiting for your payment confirmation. Once approved, this page will unlock the setup.",
      syncId: "Sync ID", copyHint: "Copy this info in case you need to contact us.",
      notFoundTitle: "Code not found", notFoundDesc: "Please check that your panel code is correct.",
      backToPlans: "Back to plans", codeCopied: "Code copied!",
    },
    step1: {
      attention: "ATTENTION: read every detail on this page carefully. Only contact support if you don't understand.",
      selectSystem: "Select your system type below:",
      oneServerNote: "You can sync as many times as you want on 1 server. If you have more than 1 server, contact support.",
      serverData: "Server Details", manualTitle: "Manual Setup",
      manualDesc: "If you don't have your MAIN's database user, create one by running the commands below via SSH on your MAIN server.",
      copyUseSuggested: "Copy and use suggested user and password", autoTitle: "Automatic Setup",
      autoDesc: "To set the main IP, create a new database user and open the firewall, copy and run the command below on your server via SSH:",
      copyCommand: "Copy Command", commandCopied: "Command copied!", cmdsCopied: "Commands copied!",
      ipLabel: "MAIN Server IP *", ipLocked: "Fixed IP — locked after the 1st save. To change it, contact support.",
      ipPlaceholder: "e.g. 45.180.20.150", portLabel: "Database Port *", dbNameLabel: "Database Name *",
      dbUserLabel: "Database User *", dbUserPlaceholder: "user", dbPassLabel: "Database Password",
      dbPassPlaceholder: "Leave blank to keep the existing password",
      notifData: "Notification Details", botAccess: "Telegram Bot Access",
      botS1: "Click the button below to open our bot.", botS2: "Inside the bot, tap Start.",
      botS3: "The bot will send you your Chat ID — copy the number.", botS4: "Paste the Chat ID in the field below and click Next to save.",
      openBot: "Open the Telegram Bot", sendTest: "Send test", chatIdLabel: "Telegram Chat ID",
      chatIdRegistered: "Registered. You can change the Chat ID anytime (account/bot change).",
      testConn: "Test connection", fillIpUser: "Fill in the IP and database user.",
      savedStep1: "Step 1 saved! Let's go to the sync settings.",
    },
    common: { back: "Back", saveAdvance: "Save and continue", saveStartSync: "Save and start sync", advance: "Next", loading: "Loading…" },
    steps: {
      s2movies: "Movie Settings", s2series: "Series Settings",
      s3how: "How do you want to provide your M3U?", s3source: "Your M3U source", s3settings: "Settings",
      s4tmdb: "TMDB Settings", s4movies: "Movie Settings", s4series: "Series Settings",
      s5maint: "Maintenance Tools", s5progress: "Overall progress", s5remaining: "Remaining",
      s5copy: "Copy", s5msgCopied: "Message copied!",
      s5autoOn: "Auto Sync", s5autoOff: "Enable Auto Sync",
      s5stop: "Stop Sync", s5restart: "Restart Sync",
      s5every: "Sync every day at", s5deact: "Disable", s5saveAct: "Save and enable",
      s5chgConfig: "Change Settings", s5chgSystem: "Change System",
    },
  },
  es: {
    nav: {
      avisos: "Avisos", avisosDesc: "Comunicados importantes de WX SyncVods.",
      suporte: "Soporte", suporteDesc: "Habla con nuestro equipo.",
      suporteBody: "¿Dudas sobre planes o sincronización? Escríbenos por Telegram — respondemos rápido.",
      telegramBtn: "Hablar por Telegram", meuPainel: "Mi Panel",
      acessar: "Acceder a mi panel", acessarDesc: "Pega el código único que recibiste en la compra.",
      entrar: "Entrar", codePlaceholder: "ej: bb70f097-7c16-4e6c-93b1-e3f38cda0d62",
    },
    landing: {
      expiryWarn: "Atención: mantén tu suscripción activa para garantizar la sincronización automática de nuevo contenido.",
      intro: "Este script te permite agregar películas y series (VODs) automáticamente en un servidor de tu elección.",
      contactBefore: "Contacta a nuestro equipo para saber si este script te sirve antes de comprar.",
      supported: "Sistemas compatibles:", subscribe30: "Suscribirse por 30 días", buyOne: "Comprar 1 sincronización",
      footer: "WX SyncVods — Sincronizador de VODs para XUI ONE, XTREAM UI, STREAMCREED, 1-STREAM y más",
    },
    plans: {
      period30: "por 30 días", periodOnce: "1 sincronización",
      ctaSub: "Suscribirse por 30 días", ctaOnce: "Comprar 1 Sincronización",
      badgeMost: "Más Elegido", badgeBest: "Mejor Precio",
      descMoviesSeries: "Sincronización ilimitada y automática de películas y series para 1 servidor.",
      descMovies: "Sincronización ilimitada y automática de películas para 1 servidor.",
      descSeries: "Sincronización ilimitada y automática de series para 1 servidor.",
      descOnce: "Esta opción te permite sincronizar 1 vez en 1 servidor durante 24 horas.",
      infoOnce: "Después de 24 horas tendrás que comprar otra sincronización si quieres usar el script de nuevo.",
      titleMoviesSeries: "Películas y Series", titleMovies: "Películas", titleSeries: "Series",
    },
    checkout: {
      back: "Volver a los planes", buying: "Estás comprando", planNotFound: "Plan no encontrado.", backBtn: "Volver",
      approvedTitle: "¡Pago aprobado!", sentCode: "Enviamos tu código a", yourCode: "Tu código único",
      gotoPanel: "Ir a mi panel", pixTitle: "Paga con PIX", pixDesc: "Escanea el QR o copia el código de abajo.",
      pixCopied: "¡Código PIX copiado!", waitingPix: "Esperando la confirmación del pago…",
      boletoTitle: "Boleto generado", boletoDesc: "Abre el boleto, págalo y tu panel se liberará tras la acreditación.",
      openBoleto: "Abrir boleto", waiting: "Esperando el pago…",
      emailLabel: "Tu correo (para recibir el código)", emailPlaceholder: "tu@correo.com",
      emailInvalid: "Ingresa un correo válido", continue: "Continuar al pago",
      choosePayment: "Elige PIX, tarjeta de crédito o boleto — todo aquí en el sitio.",
      codeCopied: "¡Código copiado!", status: "Estado",
    },
    panel: {
      clientPanel: "Panel del cliente", daysRemaining: "Días restantes", expiresAt: "Expira el", system: "Sistema",
      statusActive: "Activo", statusSuspended: "Suspendido", statusPending: "Esperando pago",
      stepLabel: "Paso", renewBtn: "Renovar / Comprar plan",
      inactiveSuspended: "Tu suscripción expiró. Renueva un plan para reactivar la sincronización. Tu código y enlace siguen válidos tras la renovación.",
      inactivePending: "Estamos esperando la confirmación de tu pago. En cuanto se apruebe, esta página liberará la configuración.",
      syncId: "ID de Sincronización", copyHint: "Copia esta información por si necesitas contactarnos.",
      notFoundTitle: "Código no encontrado", notFoundDesc: "Verifica que el código de tu panel sea correcto.",
      backToPlans: "Volver a los planes", codeCopied: "¡Código copiado!",
    },
    step1: {
      attention: "ATENCIÓN: lee con atención cada detalle de esta página. Solo contacta al soporte si no entiendes.",
      selectSystem: "Selecciona el tipo de tu sistema abajo:",
      oneServerNote: "Puedes sincronizar cuantas veces quieras en 1 servidor. Si tienes más de 1 servidor, contacta al soporte.",
      serverData: "Datos del Servidor", manualTitle: "Configuración Manual",
      manualDesc: "Si no tienes el usuario de la base de datos de tu MAIN, crea uno ejecutando los comandos de abajo por SSH en tu servidor MAIN.",
      copyUseSuggested: "Copiar y usar usuario y contraseña sugeridos", autoTitle: "Configuración Automática",
      autoDesc: "Para configurar la IP del main, crear un nuevo usuario de base de datos y abrir el firewall, copia y ejecuta el comando de abajo por SSH:",
      copyCommand: "Copiar Comando", commandCopied: "¡Comando copiado!", cmdsCopied: "¡Comandos copiados!",
      ipLabel: "IP del Servidor MAIN *", ipLocked: "IP fija — bloqueada tras el 1er registro. Para cambiarla, contacta al soporte.",
      ipPlaceholder: "ej: 45.180.20.150", portLabel: "Puerto de la Base de Datos *", dbNameLabel: "Nombre de la Base *",
      dbUserLabel: "Usuario de la Base de Datos *", dbUserPlaceholder: "usuario", dbPassLabel: "Contraseña de la Base",
      dbPassPlaceholder: "Déjalo en blanco para usar la contraseña actual",
      notifData: "Datos para Notificación", botAccess: "Acceso al Bot de Telegram",
      botS1: "Haz clic en el botón de abajo para abrir nuestro bot.", botS2: "Dentro del bot, toca Start (Iniciar).",
      botS3: "El bot te enviará tu Chat ID — copia el número.", botS4: "Pega el Chat ID en el campo de abajo y haz clic en Siguiente para guardar.",
      openBot: "Abrir el Bot de Telegram", sendTest: "Enviar prueba", chatIdLabel: "Telegram Chat ID",
      chatIdRegistered: "Registrado. Puedes cambiar el Chat ID cuando quieras (cambio de cuenta/bot).",
      testConn: "Probar conexión", fillIpUser: "Completa la IP y el usuario de la base.",
      savedStep1: "¡Paso 1 guardado! Vamos a la configuración de sincronización.",
    },
    common: { back: "Volver", saveAdvance: "Guardar y continuar", saveStartSync: "Guardar e iniciar sincronización", advance: "Siguiente", loading: "Cargando…" },
    steps: {
      s2movies: "Configuración de Películas", s2series: "Configuración de Series",
      s3how: "¿Cómo quieres indicar tu M3U?", s3source: "Tu fuente M3U", s3settings: "Configuración",
      s4tmdb: "Configuración de TMDB", s4movies: "Configuración de Películas", s4series: "Configuración de Series",
      s5maint: "Herramientas de Mantenimiento", s5progress: "Progreso general", s5remaining: "Faltan",
      s5copy: "Copiar", s5msgCopied: "¡Mensaje copiado!",
      s5autoOn: "Sincronización Automática", s5autoOff: "Activar Sincronización Automática",
      s5stop: "Detener Sincronización", s5restart: "Reiniciar Sincronización",
      s5every: "Sincronizar cada día a las", s5deact: "Desactivar", s5saveAct: "Guardar y activar",
      s5chgConfig: "Cambiar Configuración", s5chgSystem: "Cambiar Sistema",
    },
  },
};

const LANG_MAP = { BR: "pt", EN: "en", ES: "es" };
const LangContext = createContext({ lang: "BR", setLang: () => {}, t: (k) => k });

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("wx_lang") || "BR");
  useEffect(() => { localStorage.setItem("wx_lang", lang); }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback((path, vars) => {
    const code = LANG_MAP[lang] || "pt";
    const val = path.split(".").reduce((o, k) => (o ? o[k] : undefined), DICT[code])
      ?? path.split(".").reduce((o, k) => (o ? o[k] : undefined), DICT.pt) ?? path;
    if (vars && typeof val === "string") {
      return Object.keys(vars).reduce((s, k) => s.replace(`{${k}}`, vars[k]), val);
    }
    return val;
  }, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
};

export const useI18n = () => useContext(LangContext);
export const useT = () => useContext(LangContext).t;
